import b_thesis from './images/b_thesis.png';
import poster from './images/Poster.png';
import flutter from './images/todoflutter.jpg';
import flutter2 from './images/todoflutter2.jpg';


const projectsData = [
  {
    title: "MatchLit",
    description: "Two-sided marketplace connecting brands with influencer\ncreators. Built with Next.js, Supabase, Stripe Connect,\nand Drizzle ORM with real-time messaging and escrow payments",
    link: "https://matchlit.ai",
    image: ""
  },
  {
    title: "Sarcasm Detection",
    description: "NLP models trained to detect sarcasm in news\nheadlines. Try the live demo, the models run\nright in your browser",
    link: "https://hasanoma.github.io/tdt13_sarcasm_detection_in_news_headlines/",
    image: ""
  },
  {
    title: "Prisoners dilemma",
    description: "Axelrod-style strategy tournament. Run it live,\nwatch duels move by move, or play against\nthe strategies yourself",
    link: "https://hasanoma.github.io/Prisoners_dilemma/",
    image: poster
  },
  {
    title: "NLP Radicalization Study",
    description: "Master's thesis: Cross-ideological NLP analysis of\nextremist rhetoric using DeBERTa and DistilBERT\ntransformers on 1.2M+ social media records",
    link: "https://github.com/HasanOma/the-language-of-radicalization",
    image: ""
  },
  {
    title: "Trotter",
    description: "Flat-priced, mobile-first pet-sitting platform\nbuilt in TypeScript, live on Vercel",
    link: "https://trotter-woad.vercel.app",
    image: ""
  },
  {
    title: "Yawmi: Daily Hadith",
    description: "A daily hadith companion. React Native (Expo)\napp with a live web version",
    link: "https://yawmi-hadith.vercel.app",
    image: ""
  },
  {
    title: "Bachelor Thesis",
    description: "Web app made for Accenture tracking real-time\nmarine activity in Trondheim fjord",
    link: "",
    image: b_thesis
  },
  {
    title: "Onion Routing Network",
    description: "Multi-node anonymity network built from scratch\nwith RSA/AES encryption and fault tolerance",
    link: "https://github.com/HasanOma/nettverk_prosjekt_OnionRouting",
    image: ""
  },
  {
    title: "Flutter todo app",
    description: "Fully functioning todo app with sqlite db",
    link: "https://github.com/HasanOma/IDATT2506-prosjekt/tree/main/project",
    image: flutter,
    image2: flutter2
  },
  {
    title: "Portfolio site",
    description: "This website, built with React and Tailwind CSS",
    link: "https://github.com/HasanOma",
    image: ""
  }
];

export default projectsData;
